import type { ComponentProps } from 'react'
import CaptionTextBlock from '../TextBlocks/CaptionTextBlock'
import { useIntl } from 'react-intl'

type InheritedCaptionTextBlockProps = Pick<ComponentProps<typeof CaptionTextBlock>, 'endIcon'>

interface Props extends InheritedCaptionTextBlockProps {
}

function PriceRowTaxesAndFees(props: Props) {
  const { endIcon } = props
  const intl = useIntl()

  return <CaptionTextBlock
    variant="medium"
    weight="normal"
    colour="light-foreground-alt"
    endIcon={endIcon}
  >
    {intl.formatMessage({
      id: 'H29_x-SS95OszUi2OiUM',
      defaultMessage: 'Includes taxes & fees',
    })}
  </CaptionTextBlock>
}

export default PriceRowTaxesAndFees
